module.exports = __webpack_public_path__ + "media/wukong.a83839b5.mp3";